import { infiniteMUActions } from 'actions/infiniteMUActions';
import omit from 'lodash/omit';
const defaultState = {};
export default function infiniteMU(state = defaultState, action) {
    switch (action.type) {
        case infiniteMUActions.CLEAR_INFINITE_MU:
            return omit(state, [action.wid]);
        case infiniteMUActions.INFINITE_MU_SUCCESS:
            const prevItems = state[action.wid] || [];
            const newItems = Object.keys(action.data).map(key => action.data[key].component);
            return Object.assign(Object.assign({}, state), { [action.wid]: [...prevItems, ...newItems] });
        default:
            return state;
    }
}
